var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay',_vm._g(_vm._b({},'overlay',_vm.$attrs,false),_vm.$listeners),[_c('div',{ref:"body",staticClass:"absolute inset-0 h-full overflow-y-scroll scrolling-touch overlaymenu__body scrollbars-hidden"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }